import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";
import "./DuplicateModal.scss";

export function DuplicateModal({ duplicate,...props }) {
  const [t] = useTranslation();

  return (
    <Modal {...props} centered dialogClassName="duplicate-modal">
      <Modal.Header className="duplicate-modal-header" closeButton>
        <div className="title">{t("CreateNewReceip")}</div>
      </Modal.Header>
      <Modal.Body className="duplicate-modal-content">
        <div className="sub-title">{t("CreateNewReceipAdvertise")}</div>
        <div className="button-wrapper">
          <Button className="button-cancel" onClick={() => props.onHide()}>
            {t("Close")}
          </Button>
          <Button className="button" onClick={duplicate}>
            {t("Create")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
